import { validationMixin } from 'vuelidate'

export const prebuiltModelValidation = {
  mixins: [validationMixin],

  computed: {
    errors () {
      const errors = {}
      const { importModal } = this.$v

      if (importModal.$dirty) {
        if (!importModal.newContextName) {
          errors.newContextName = this.$t('validations.prebuilt-model-validation.newContextName.required')
        } else if (!importModal.context) {
          errors.context = this.$t('validations.prebuilt-model-validation.contextName.required')
        }
      }

      return errors
    }
  },

  validations: {
    importModal: {
      newContextName: (value, { importModal, contexts }) => {
        if (!importModal.createNewContext) {
          return true
        }
        return !!value.newContextName && !contexts.find(context => context.name === value.newContextName)
      },
      context: (value, { importModal }) => {
        if (importModal.createNewContext) {
          return true
        }
        return !!value.context
      }
    }
  }
}
